import { makeObservable, observable } from 'mobx'
import { EMPTY_NUMBER_ID } from 'src/constant/common'

import { DTO } from '../DTO'

export class ArithmeticCurriculumKeyWorksheet extends DTO {
  id: res.Worksheet['id'] = EMPTY_NUMBER_ID
  title: res.Worksheet['title'] = ''
  problemCount: res.Worksheet['problemCount'] = 0
  type: res.ArithmeticWorksheet['type']
  thumbnail: res.ArithmeticWorksheet['thumbnail']
  sectionOrderingNumber: res.ArithmeticWorksheet['sectionOrderingNumber']
  orderingNumber: res.ArithmeticWorksheet['orderingNumber']

  constructor(data) {
    super()

    makeObservable(this, {
      id: observable,
      title: observable,
      problemCount: observable,
      type: observable,
      thumbnail: observable,
      sectionOrderingNumber: observable,
      orderingNumber: observable,
    })

    this.id = data.id
    this.title = data.title
    this.problemCount = data.problemCount
    this.type = data.type
    this.thumbnail = data.thumbnail
    this.sectionOrderingNumber = data.sectionOrderingNumber
    this.orderingNumber = data.orderingNumber
  }
}
